import * as routes from 'routes';
import { withQuery } from 'utils/query';

import { NAVIGATION } from '../actions/navigation';

export function buildNavigationPath() {
  const queries = { action: NAVIGATION };
  return withQuery(routes.redirect, queries);
}
